import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate } from '../../utils/helpers';

const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayOf = (d) => { const t = new Date(`${String(d || '').slice(0, 10)}T00:00:00`); return Number.isNaN(t.getTime()) ? '' : DAY[t.getDay()]; };

// Phone / APK "Group (count only)" - full screen, thumb-sized: name, a − N +
// stepper for persons, whose guests, the functions as full-width tap rows,
// card as two buttons. "Save & next" keeps whose / functions / card.
// Logic in useCountGroup.
export default function CountGroupFormMobile({ vm }) {
  const {
    groupForm, setG, toggleGroupFunction, setAllGroupFunctions, groupFunctions, memberOptions,
    saveGroup, groupSaving, setGroupOpen,
  } = vm.countGroup;
  const editing = !!groupForm.GuestId;
  const n = Number(groupForm.Persons || 0);
  const step = (d) => setG('Persons', String(Math.min(500, Math.max(1, n + d))));

  return (
    <Modal fullScreen className="cg-modal-m" title={editing ? 'Group (count only)' : 'Add group (count only)'}
      onClose={() => setGroupOpen(false)}
      footer={<>
        {!editing && (
          <button className="btn light" style={{ flex: 1, padding: 12 }} onClick={() => saveGroup({ next: true })} disabled={groupSaving}>Save &amp; next</button>
        )}
        <button className="btn primary" style={{ flex: 1, padding: 12 }} onClick={() => saveGroup()} disabled={groupSaving}>
          {groupSaving ? 'Saving…' : 'Save'}
        </button>
      </>}>
      <label className="field">Group name *
        <input value={groupForm.GuestName} placeholder="e.g. School Friends" maxLength={60}
          onChange={(e) => setG('GuestName', e.target.value)} />
      </label>

      <div className="cg-m-row">
        <div className="field cg-m-persons">Persons *
          <div className="cg-stepper">
            <button type="button" onClick={() => step(-1)} aria-label="One less">−</button>
            <input inputMode="numeric" value={groupForm.Persons} placeholder="0"
              onChange={(e) => setG('Persons', e.target.value.replace(/\D/g, '').slice(0, 3))} />
            <button type="button" onClick={() => step(1)} aria-label="One more">+</button>
          </div>
        </div>
        <div className="field cg-m-card">Card
          <div className="cg-seg">
            <button type="button" className={!groupForm.Card ? 'on' : ''} onClick={() => setG('Card', false)}>No card</button>
            <button type="button" className={groupForm.Card ? 'on' : ''} onClick={() => setG('Card', true)}>One card</button>
          </div>
        </div>
      </div>

      <label className="field">Guest of *
        <select value={groupForm.MemberId} onChange={(e) => setG('MemberId', e.target.value)}>
          <option value="">- select member -</option>
          {memberOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </label>

      <div className="cg-fn-head">
        <span className="step-label">Invited to</span>
        <span className="cg-fn-tools">
          <button type="button" className="link-btn" onClick={() => setAllGroupFunctions(true)}>All</button>
          <button type="button" className="link-btn" onClick={() => setAllGroupFunctions(false)}>None</button>
        </span>
      </div>
      <div className="cg-m-fns">
        {groupFunctions.map(f => {
          const on = groupForm.FunctionIds.includes(String(f.FunctionId));
          return (
            <button key={f.FunctionId} type="button" className={'cg-m-fn' + (on ? ' on' : '')}
              onClick={() => toggleGroupFunction(f.FunctionId)}>
              <span className="cg-m-check">{on ? '✓' : ''}</span>
              <span className="cg-fn-name">{f.FunctionName}</span>
              <span className="cg-fn-date">{dayOf(f.FunctionDate)} {fmtDate(f.FunctionDate).slice(0, 5)}</span>
            </button>
          );
        })}
      </div>
    </Modal>
  );
}
